import { render, staticRenderFns } from "./ProductCost1.vue?vue&type=template&id=fcd56e14&scoped=true"
import script from "./ProductCost1.vue?vue&type=script&lang=js"
export * from "./ProductCost1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd56e14",
  null
  
)

export default component.exports